<script setup>
import PayrollTable from './PayrollTable.vue';
import FileExport from './FileExport';
</script>

<template>
  <div>
    <div class="mb-2">
      <RouterLink to="/payroll/edit" class="button is-light">
        <font-awesome-icon :icon="['fas', 'chevron-left']" />
        <span class="ml-2">Editar</span>
      </RouterLink>
    </div>

    <div class="card">
      <div class="card-content">
        <div>
          <div class="has-text-right">
            <RouterLink to="/payroll/upload" class="button mr-2 is-light">
              <font-awesome-icon :icon="['fas', 'file']" />
              <span class="ml-2">Novo</span>
            </RouterLink>

            <FileExport/>
          </div>
          <PayrollTable :payroll="payrollFiltered" :edit="false"/>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-content">
        <div class="column">
          <div class="is-size-6">
            Honorários: {{ getCurrency(fee) }} ({{ feePercentage }})
          </div>

          <div class="has-text-weight-bold">
            Valor total: {{ getCurrency(totalValueWithFee) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    payrollFiltered() {
      const payroll = JSON.parse(sessionStorage.payrollFiltered);
      return payroll;
    },
    feePercentage() {
      return `${this.payrollFiltered.fee * 100}%`;
    },
    fee() {
      return this.totalValue * (this.payrollFiltered.fee);
    },
    totalValueWithFee() {
      return this.totalValue * (1 + this.payrollFiltered.fee);
    },
    totalValue() {
      return  this.payrollFiltered.payments.reduce((partialSum, payment) => partialSum + this.paymentTotalValue(payment), 0);
    }
  }, methods: {
    getCurrency(value) {
      if (value === null || isNaN(value)) return '';
      return value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    paymentTotalValue(payment) {
      const total = (payment.value * 0.08)
        * (payment.tr ? 1 + payment.tr : 1)
        * (payment.selic ? 1 + payment.selic : 1)
        * (payment.poupanca ? 1 + payment.poupanca : 1);

        return total;
    }
  }
};
</script>

<style>
  .sticky {
    position: sticky;
    top: 0;
    z-index: 2;
  }
</style>